import React, { useCallback } from 'react';
import { OptionKey, useQueryClient } from '@common-fe/common-fe';

import { API_URL } from '@/dtos';
import ReissuePaymentModal from '@/modules/employer/components/ReconciliationReports/ReissuePaymentModal/ReissuePaymentModal';

import { Check } from './constants';
import useReissueCheckQuery from './useReissueCheck.query';

interface Props {
  isVisible: boolean;
  close: () => void;
  check: Check;
  refetch?: () => void;
  okButtonText?: string;
}

const ReissueCheckPopup: React.FC<Props> = ({ check, isVisible, close, refetch, okButtonText }) => {
  const queryClient = useQueryClient();
  const { mutateAsync: reissueCheck } = useReissueCheckQuery(check.id);

  const handleSubmit = useCallback(
    async (selectedPaymentMethodId: OptionKey) => {
      await reissueCheck(selectedPaymentMethodId as string);
    },
    [reissueCheck]
  );

  const onSuccessClose = useCallback(() => {
    if (refetch) {
      refetch();
    } else {
      queryClient.invalidateQueries({
        queryKey: [API_URL.CHECKS_SEARCH],
      });
    }
  }, [refetch, queryClient]);

  return (
    <ReissuePaymentModal
      isVisible={isVisible}
      check={check}
      onClose={close}
      onSubmit={handleSubmit}
      onSubmitSuccess={close}
      onSuccessClose={onSuccessClose}
      successButtonText={okButtonText || 'Go Back To Checks'}
      wrapperStyle={{ zIndex: 2002 }}
    />
  );
};

export default ReissueCheckPopup;
